<template>
  <div id="reimbursement">
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-form @submit="onSubmit" class="detail-form">
      <van-field
        v-if="detailForm.detail !== '企业滴滴'"
        name="reim_type"
        :value="detailForm.reim_type_cn"
        label="付费类型"
        @click="showReimType"
        placeholder="单位"
      />
      <van-field
        v-if="detailForm.detail === '企业滴滴'"
        name="reim_type"
        :value="detailForm.reim_type_cn"
        label="付费类型"
        placeholder="单位"
        readonly
      />
      <van-popup v-model="showReimPicker" position="bottom">
        <van-picker
          v-if="showReimPicker"
          title="付费类型"
          show-toolbar
          :columns="feeType"
          value-key="k"
          @confirm="onConfirmFeeType"
          @cancel="onCancelFeeType"
          @change="onChange"
        />
      </van-popup>
        <van-field
          v-if="detailForm.detail !== '企业滴滴' && detailForm.reim_type_cn !== '自驾'"
          name="name"
          v-model="detailForm.detail"
          label="明细"
          placeholder="明细"
          :rules="[{ required: true, message: '明细' }]"
        />
      <van-field
        v-if="detailForm.detail === '企业滴滴' && detailForm.reim_type_cn !== '自驾'"
        name="name"
        v-model="detailForm.detail"
        label="明细"
        placeholder="明细"
        readonly
        :rules="[{ required: true, message: '明细' }]"
      />
        <!--<div style="overflow: hidden; padding-bottom: 10px; padding-left: 10px;" v-if="detailForm.detail !== '企业滴滴'">
          <div class="order_tips_item" @click="changeDetail('人工费')">人工费</div>
          <div class="order_tips_item" @click="changeDetail('交通费')">交通费</div>
        </div>-->
      <van-field
        name="picker"
        v-if="detailForm.reim_type_cn === '自驾'"
        v-model="detailForm.from_address"
        type="textarea"
        label="出发地"
        placeholder="备注"
      />
      <van-field
        name="picker"
        v-if="detailForm.reim_type_cn === '自驾'"
        v-model="detailForm.to_address"
        type="textarea"
        label="到达地"
        placeholder="到达地"
      />
      <van-button v-if="detailForm.reim_type_cn === '自驾'" type="primary" @click="calculateDistance" />
      <van-field
          name="num"
          v-model="detailForm.num"
          label="数量"
          type="digit"
          placeholder="数量"
          :rules="[{ required: true, message: '数量' }]"
        />
        <van-field
          name="unit"
          :value="detailForm.unit"
          label="单位"
          @click="showColumns"
          placeholder="单位"
          :rules="[{ required: true, message: '单位' }]"
        />
        <van-popup v-model="showUnitPicker" position="bottom">
          <van-picker
            v-if="showUnitPicker"
            title="单位"
            show-toolbar
            :columns="columns"
            value-key="value"
            @confirm="onConfirm"
            @cancel="onCancel"
            @change="onChange"
          />
        </van-popup>
        <van-field
          name="price"
          v-model="detailForm.price"
          label="单价 (元)"
          placeholder="单价 (元)"
          type="number"
          :rules="[{ required: true, message: '请填写单价' }]"
        />
        <van-field
          readonly
          clickable
          name="total_price"
          v-model="detailForm.total_price"
          label="小计"
          placeholder="小计"
        />
        <van-field
            name="unit"
            :value="detailForm.worker"
            label="合作工人"
            @click="showWorkers"
            placeholder="合作工人"
        />
        <van-popup v-model="showWorker" position="bottom">
          <van-picker
              v-if="showWorker"
              title="工人"
              show-toolbar
              :columns="workerList"
              value-key="worker"
              @confirm="onConfirmWorker"
              @cancel="onCancelWorker"
              @change="onChange"
          />
        </van-popup>
        <van-field
          name="picker"
          v-if="detailForm.reim_type !== qy_di_di_reim_type && detailForm.reim_type !== qy_huo_la_la_reim_type"
          v-model="detailForm.remark"
          type="textarea"
          label="备注"
          placeholder="备注"
        />
      <van-cell v-if="detailForm.reim_type === qy_di_di_reim_type || detailForm.reim_type === qy_huo_la_la_reim_type" title="选择打车日期" @click="showDiDi" is-link />
      <div v-for="(item, index) in car_date_list" style="overflow: hidden; background-color: #FFF; padding-left: 5vw; padding-right: 5vw; border-bottom: solid 1px #e6e6e6; line-height: 2rem; ">
          <div style="float: left; " @click="showDate(item, index)">{{ item }}</div>
          <div style="float: right"><van-icon name="delete-o" class="delete-icon" @click="deleteDate(index)" /></div>
      </div>
      <div style="margin: 16px;width: 300px; margin: 0 auto;">
        <van-button v-if="editStatus" type="info" style="width: 80px; height: 35px; border-radius: 5px;float: left;margin-top: 20px; margin-left: 50px;" native-type="button" @click="onClickLeft">返回</van-button>
        <van-button v-if="editStatus" type="info" style="width: 80px; height: 35px; border-radius: 5px;float: left;margin-top: 20px; margin-left: 50px;" native-type="submit">保存</van-button>
        <div clear="both"></div>
      </div>
    </van-form>

    <van-popup v-model="showCalendar" :style="{ width: '100%' }">
      <van-datetime-picker
        v-if="showCalendar"
        v-model="currentDate"
        type="datetime"
        title="选择完整时间"
        @confirm="confirmDate"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>
<script>
import * as math from 'mathjs'
import {qyts} from '@/api/order'
import {createOrUpdateRemiDetail} from "../../../api/reimbursement";
import {getCooperateWorkerList} from "../../../api/user";
import {Notify} from "vant";
import dayjs from "dayjs";

export default {
  name: 'reimbursementDetail',
  props: {
    showContent: {
      type: Object,
      default: null
    },
    editStatus: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentIndex: -1,
      detailForm: {
        remark: '',
        detail: '',
        num: '',
        unit: '',
        reim_detail_id: '',
        total_price: '',
        price: '',
        reim_type_cn: '材料费',
        reim_type: 'material_fee',
        car_date_list: []
      },
      car_date_list: [],
      columns: [],
      workerList: [],
      feeType: [
        {
          k: '人工费',
          v: 'labor_cost'
        },
        {
          k: '材料费',
          v: 'material_fee'
        },
        {
          k: '交通费',
          v: 'transportation_fee',
        },
        {
          k: '住宿费',
          v: 'accommodation_fee',
        },
        {
          k: '差补',
          v: 'allowance',
        }
      ],
      showPicker: false,
      title: '',
      showUnitPicker: false,
      showWorker: false,
      showReimPicker: false,
      qy_di_di_reim_type_cn: '企业滴滴',
      qy_di_di_reim_type: 'qy_di_di',
      qy_huo_la_la_reim_type_cn: '企业货拉拉',
      qy_huo_la_la_reim_type: 'qy_huo_la_la',
      currentDate: new Date(),
      maxDate: new Date(),
      showCalendar: false,
    }
  },
  created () {
    if (this.showContent && this.showContent.key) {
      this.detailForm = this.showContent
    } else if (this.showContent && this.showContent.reim_detail_id) {
      this.detailForm = this.showContent
      if (this.showContent && this.showContent.detail === '企业滴滴') {
        this.detailForm.reim_type_cn = this.qy_di_di_reim_type_cn
        this.detailForm.reim_type = this.qy_di_di_reim_type
        if (this.detailForm.remark.length > 0) {
          this.car_date_list = this.detailForm.remark.split(',')
        }
      }
      if (this.showContent && this.showContent.detail === '企业货拉拉') {
        this.detailForm.reim_type_cn = this.qy_huo_la_la_reim_type_cn
        this.detailForm.reim_type = this.qy_huo_la_la_reim_type
        if (this.detailForm.remark.length > 0) {
          this.car_date_list = this.detailForm.remark.split(',')
        }
      }
    } else {
      this.detailForm = {
        remark: '',
        detail: '',
        num: '',
        unit: '',
        reim_detail_id: '',
        total_price: '',
        price: '',
        worker_uid: '',
        reim_type_cn: '材料费',
        reim_type: 'material_fee',
        car_date_list: []
      }
    }
    this.minDate = dayjs().subtract(1, 'month').toDate()
    this.maxDate = dayjs().add(1, 'day').toDate()
    if (this.detailForm.reim_type) {
      for (const item in this.feeType) {
        if (this.feeType[item].v === this.detailForm.reim_type) {
          this.detailForm.reim_type_cn = this.feeType[item].k
        }
      }
    }

    this.initQyts()
    this.initWorkers()
  },
  watch: {
    detailForm: {
      handler(new_value, old_value) {
        if (new_value.num && new_value.price) {
          this.detailForm.total_price = math.round(new_value.num * new_value.price, 2)
        }
      },
      deep: true
    }
  },
  methods: {
    calculateDistance() {

    },
    showDate(value, index) {
      this.showCalendar = true
      this.currentIndex = index
      this.currentDate = dayjs(value).toDate()
    },
    confirmDate(value) {
      if (this.currentIndex <= -1) {
        this.car_date_list.push(dayjs(value).format('YYYY-MM-DD HH:mm:ss'))
      } else {
        this.car_date_list[this.currentIndex] = dayjs(value).format('YYYY-MM-DD HH:mm:ss')
        this.$set(this.car_date_list, this.currentIndex, this.car_date_list[this.currentIndex])
      }
      this.showCalendar = false
    },
    showDiDi() {
      this.showCalendar = true
      this.currentDate = new Date()
    },
    deleteDate(index) {
      this.car_date_list.splice(index, 1)
    },
    changeDetail(val) {
      this.detailForm.detail = val
      this.$forceUpdate()
    },
    initWorkers() {
      getCooperateWorkerList({}).then((res) => {
        if (res.data.data) {
          this.workerList = res.data.data
        }
      })
    },
    onConfirmWorker(evt) {
      console.log('vet.....', evt)
      this.detailForm.worker = evt.worker
      this.detailForm.worker_uid = evt.worker_uid
      this.showWorker = false
      if (evt.worker_uid > 0) {
        this.detailForm.reim_type_cn = '人工费'
        this.detailForm.reim_type = 'labor_cost'
      }
    },
    onCancelWorker() {
      this.showWorker = false
    },
    onCancelFeeType() {
      this.showReimPicker = false
    },
    showWorkers() {
      this.showWorker = true
    },
    showReimType() {
      this.showReimPicker = true
    },
    initQyts() {
      qyts().then((res) => {
        if (res.data.data) {
          this.columns = res.data.data
        }
      })
    },
    genNonDuplicateID(){
      let idStr = Date.now().toString(36)
      idStr += Math.random().toString(36).substr(2)
      return idStr
    },
    onSubmit() {
      if (this.detailForm.detail) {
        console.log('detail...........', this.detailForm.detail)
        /*createOrUpdateRemiDetail(this.detailForm).then((res) => {
          if (res.data.data) {
            this.detailForm.reim_detail_id = res.data.data
          }
        })*/
        if (this.detailForm.detail === '企业滴滴' && this.car_date_list.length > 0) {
          this.detailForm.remark = this.car_date_list.join(',')
        }

        if (this.detailForm.detail === '企业货拉拉' && this.car_date_list.length > 0) {
          this.detailForm.remark = this.car_date_list.join(',')
        }

        if (this.detailForm.reim_detail_id === '' || typeof this.detailForm.reim_detail_id === 'undefined') {
          this.detailForm.reim_detail_id = this.genNonDuplicateID()
        }
        this.$emit('updateContent', this.detailForm)
      } else {
        Notify({ type: 'danger', message: '请填写明细信息' });
      }
    },
    onClickLeft () {
      this.$emit('actContent', null)
    },
    onCancel() {
      this.showUnitPicker = false
    },
    onConfirm(evt) {
      this.showUnitPicker = false
      this.detailForm.unit = evt.value
    },
    onConfirmFeeType(evt) {
      this.showReimPicker = false
      this.detailForm.reim_type_cn = evt.k
      this.detailForm.reim_type = evt.v
    },
    onChange() {

    },
    showColumns() {
      this.showUnitPicker = true
    }
  }
}
</script>

<style scoped>
.order_tips_item {
  cursor: pointer;
  padding: 10px 20px;
  float: left;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  border-radius: 20px;
  margin-right: 20px;
  margin-top: 10px;
  background-color: #f8f8f8;
  color: #676767;
  border: solid 1px;
}
.create-form {
  margin-top: 20px;
  border-radius: 1px;
}
.create-title {
  border-radius: 80px;
  width: 94%;
  margin: 10px auto;
}
#show-content {
  width: 94%;
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/reimbursement_detail.vue